import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { Component } from 'react';
import { AvailableIcon, OccupiedIcon, ArrowRightIcon } from './icons';

class MeetingRoomUsageList extends Component {

  render() {
    const {
      dataTable,
      onOrganizerClicked,
      onReservationButtonClicked,
    } = this.props;

    // Status Column
    const statusBodyTemplate = rowData => {
      const { room_availability } = rowData;
      const isVacant = room_availability === 1;
      return (
        <div className="status-icon">
          {isVacant ? <AvailableIcon /> : <OccupiedIcon />}
        </div>
      );
    };

    // Room Name Column
    const roomNameBodyTemplate = rowData => {
      return (
        <span className="room-name">
          {rowData.device_name || '-'}
        </span>
      );
    };

    // Current Reservation Column
    const currentReservationBodyTemplate = rowData => {
      const { current_reservation } = rowData;
      if (!current_reservation || current_reservation === '無' || current_reservation === 'なし') {
        return <span className="no-reservation">無</span>;
      }
      return <span className="reservation-time">{current_reservation}</span>;
    };

    // Organizer Column
    const organizerBodyTemplate = rowData => {
      const { organizer, employee_id } = rowData;
      if (!organizer || organizer === '無' || organizer === 'なし') {
        return null;
      }
      return (
        <button
          className="organizer-link"
          onClick={() => onOrganizerClicked({ employeeId: employee_id })}
        >
          {organizer}
        </button>
      );
    };

    // Next Reservation Column
    const nextReservationBodyTemplate = rowData => {
      const { next_reservation } = rowData;
      if (!next_reservation || next_reservation === '無' || next_reservation === 'なし') {
        return <span className="no-reservation">無</span>;
      }
      return <span className="reservation-time">{next_reservation}</span>;
    };

    // Reservation Button Column
    const reservationButtonBodyTemplate = rowData => {
      return (
        <div className="reservation-button-container">
          <button
            className="reservation-button"
            onClick={() => onReservationButtonClicked({ data: rowData })}
            title="予約"
          >
            <span className="button-icon">
              <ArrowRightIcon />
            </span>
          </button>
        </div>
      );
    };

    return (
      <div className="meeting-room-usage-list">
        <DataTable
          value={dataTable}
          showGridlines={false}
          scrollable
          scrollHeight="flex"
          className="meeting-room-datatable"
        >
          <Column
            field="room_availability"
            header="状態"
            body={statusBodyTemplate}
          />
          <Column
            field="device_name"
            header="部屋名"
            body={roomNameBodyTemplate}
          />
          <Column
            field="current_reservation"
            header="現在の予約"
            body={currentReservationBodyTemplate}
          />
          <Column
            field="organizer"
            header="予約者"
            body={organizerBodyTemplate}
          />
          <Column
            field="next_reservation"
            header="次の予約"
            body={nextReservationBodyTemplate}
          />
          <Column
            header="予約"
            body={reservationButtonBodyTemplate}
          />
        </DataTable>
      </div>
    );
  }
}

export default MeetingRoomUsageList; 
